import HideablePane from './_hideable-pane.js'

export default {
  name: 'SwitchPane',
  values: {
    container: {
      configSet: HideablePane,
      configValues: {
        enableTransitions: false,
        warnAboutUnconditionallyRenderedContent: true,
        style: {
          base: {
            minWidth: '100%',
          },
        },
      },
    },
    transitionContainerHeight: false,
  },
  meta: {
    extendable: false,
  },
}
